(() => {
  if (window.diyprintQuoteLeadReady) return;
  window.diyprintQuoteLeadReady = true;
  const forms = [...document.querySelectorAll('form.diy-bulk-form')];
  if (!forms.length || window.Shopify?.designMode) return;
  const key = 'diyprint_quote_pending_v1';
  const ttl = 2 * 60 * 60 * 1000;
  let sending = false;
  let ownsTag = false;
  let tagLoaded = false;
  const allowed = () => {
    const p = window.Shopify?.customerPrivacy;
    return !!(p?.marketingAllowed() && p.analyticsProcessingAllowed() && p.saleOfDataAllowed());
  };
  const read = () => {
    try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; }
  };
  const hidden = (form, name, value) => {
    let input = form.elements.namedItem(name);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden'; input.name = name; form.appendChild(input);
    }
    input.value = value;
  };
  forms.forEach(form => {
    form.addEventListener('submit', () => {
      if (!form.checkValidity() || !allowed()) return;
      const pending = {
        id: 'quote-' + crypto.randomUUID(),
        at: Date.now(),
        path: location.pathname,
        kind: form.elements.namedItem('contact[Form type]')?.value || 'Quote request'
      };
      try { sessionStorage.setItem(key, JSON.stringify(pending)); } catch { return; }
      hidden(form, 'contact[Tracking reference]', pending.id);
      const params = new URLSearchParams(location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(name => {
        hidden(form, 'contact[' + name + ']', (params.get(name) || '').slice(0,200));
      });
    });
  });
  const sendSuccess = () => {
    if (!allowed()) {
      if (ownsTag && window.pintrk) window.pintrk('setconsent', false);
      return;
    }
    if (sending || !forms.some(f => f.querySelector('.diy-form-success'))) return;
    const pending = read();
    if (!pending || pending.path !== location.pathname || !/^quote-[\da-f-]{36}$/.test(pending.id) ||
        !Number.isFinite(pending.at) || Date.now() - pending.at > ttl || pending.at > Date.now()) return;
    sending = true;
    const fire = () => {
      if (!allowed() || !read() || read().id !== pending.id) { sending = false; return; }
      // Clear before sending: refresh must never create another lead.
      try { sessionStorage.removeItem(key); } catch { sending = false; return; }
      window.pintrk('track', 'lead', {event_id: pending.id, lead_type: 'Quote request'});
    };
    if (window.pintrk && (!ownsTag || tagLoaded)) { fire(); return; }
    ownsTag = true;
    const tag = window.pintrk = function() { tag.queue.push(Array.from(arguments)); };
    tag.queue = []; tag.version = '3.0';
    tag('load', '2614137161694');
    tag('page');
    const script = document.createElement('script');
    script.async = true; script.src = 'https://s.pinimg.com/ct/core.js';
    script.onload = () => { tagLoaded = true; fire(); };
    script.onerror = () => { sending = false; };
    document.head.appendChild(script);
  };
  document.addEventListener('visitorConsentCollected', sendSuccess);
  if (window.Shopify?.customerPrivacy) sendSuccess();
  else window.Shopify?.loadFeatures?.([{name: 'consent-tracking-api', version: '0.1'}], error => {
    if (!error) sendSuccess();
  });
})();
